const ISSUE_ROLES = [
  "manufacturing_purchasing",
  "manufacturing",
  "platform_owner",
  "platform_admin",
  "platform_dev",
] as const;

const PLANT_CONTROL_ROLES = [
  "manufacturing_plant_manager",
  "manufacturing_plant_supervisor",
] as const;

const STATUS_ROLES = [
  ...PLANT_CONTROL_ROLES,
  "ops_reviewer",
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "trainer",
  "dev",
  "platform_owner",
  "platform_admin",
  "platform_dev",
  "platform_trainer",
] as const;

function roleSet(roles: readonly string[]): Set<string> {
  return new Set(
    roles
      .flatMap((r) => String(r).split(/[,/|]+/))
      .map((r) => r.trim().toLowerCase())
      .filter(Boolean),
  );
}

export function canIssueManufacturingPurchaseOrder(roles: readonly string[]): boolean {
  const held = roleSet(roles);
  return ISSUE_ROLES.some((r) => held.has(r));
}

export function canIssueManufacturingPurchaseOrderFromHasRole(
  hasRole: (...roles: string[]) => boolean,
): boolean {
  return hasRole(...ISSUE_ROLES);
}

export function isPlantOnlyPurchasingSeat(roles: readonly string[]): boolean {
  const held = roleSet(roles);
  const plant = PLANT_CONTROL_ROLES.some((r) => held.has(r));
  return plant && !canIssueManufacturingPurchaseOrder(roles);
}

export function isPlantOnlyPurchasingSeatFromHasRole(
  hasRole: (...roles: string[]) => boolean,
): boolean {
  const plant = hasRole(...PLANT_CONTROL_ROLES);
  return plant && !canIssueManufacturingPurchaseOrderFromHasRole(hasRole);
}

/** Plant leads + ops reviewers who should see request status (small alerts). */
export function canSeePlantRequestStatus(roles: readonly string[]): boolean {
  const held = roleSet(roles);
  return STATUS_ROLES.some((r) => held.has(r));
}

export function canSeePlantRequestStatusFromHasRole(
  hasRole: (...roles: string[]) => boolean,
): boolean {
  return hasRole(...STATUS_ROLES);
}

/** Purchasing / desk — interrupt when a request is waiting for review. */
export function canSeePurchaserRequestAlertFromHasRole(
  hasRole: (...roles: string[]) => boolean,
): boolean {
  return canIssueManufacturingPurchaseOrderFromHasRole(hasRole);
}
